import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { useHistory } from "react-router-dom";

import ENV from "config/Env";
import { typedQueryClient } from "hooks";
import { Auth, AuthKeys } from "modules/Auth/queryKeys";
import AuthService from "modules/Auth/services";
import { PATHS } from "router/paths";
import ApiInstance from "util/Api";

type GoogleLogin = {
  id_token: string;
};

const getGoogleToken = async (requestData: GoogleLogin): Promise<Auth> => {
  return ApiInstance.postUnwrapped(ENV.authBaseUrl, `/session/login/google_sign_in`, requestData, Auth);
};

export const useAuth = (): {
  loginWithGoogle: UseMutationResult<Auth, Error, GoogleLogin, unknown>;
  logout: (broadcastLogoutMessage?: boolean) => void;
  onSuccessAuth: (data: Auth, isBroadcastMessage?: boolean) => void;
} => {
  const history = useHistory();

  const onSuccessAuth = async (data: Auth) => {
    typedQueryClient.setQueryData(AuthKeys.auth, data);
    typedQueryClient.setQueryData(AuthKeys.tokenStatus, { isExpired: false });
    ApiInstance.authToken = { token: data.token, expire_at: data.expire_at };

    await AuthService.loadUser();
    history.push(PATHS.UPLOAD);
  };

  const logout = () => {
    ApiInstance.clearCookies();
    typedQueryClient.clear();
    history.replace(PATHS.LOGIN);
  };

  const googleMutation = useMutation<Auth, Error, GoogleLogin>({
    mutationFn: (credentials: GoogleLogin) => getGoogleToken(credentials),
    onSuccess: (authData: Auth) => onSuccessAuth(authData)
  });

  return { logout, loginWithGoogle: googleMutation, onSuccessAuth };
};
